module.exports = __webpack_public_path__ + "img/gray-walkman.bb3601f1.png";